"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof3 = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _findDOMNode = _interopRequireDefault(require("rc-util/lib/Dom/findDOMNode"));
var _omit = _interopRequireDefault(require("omit.js"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _rcResizeObserver = _interopRequireDefault(require("rc-resize-observer"));
var _LocaleContext = require("../locales/LocaleContext");
var _default2 = _interopRequireDefault(require("../locales/default"));
var _raf = _interopRequireDefault(require("./raf"));
var _util = _interopRequireWildcard(require("./util"));
var _Tooltip = _interopRequireDefault(require("../Tooltip"));
var _Typography = _interopRequireDefault(require("./Typography"));
var _Styled = require("./Styled");
var _ykbStyledComponents = require("../ykb-styled-components");
var _excluded = ["component", "children", "className", "type", "disabled", "style"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof3(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } // import Notification from '../Notification';
var isLineClampSupport = (0, _util.isStyleSupport)('webkitLineClamp');
var isTextOverflowSupport = (0, _util.isStyleSupport)('textOverflow');
function wrapperDecorations(_ref, content) {
  var mark = _ref.mark,
    code = _ref.code,
    underline = _ref.underline,
    del = _ref.delete,
    strong = _ref.strong,
    keyboard = _ref.keyboard;
  var currentContent = content;
  function wrap(needed, tag) {
    if (!needed) return;
    currentContent = /*#__PURE__*/React.createElement(tag, {}, currentContent);
  }
  wrap(strong, 'strong');
  wrap(underline, 'u');
  wrap(del, 'del');
  wrap(code, 'code');
  wrap(mark, 'mark');
  wrap(keyboard, 'kbd');
  return currentContent;
}
var ELLIPSIS_STR = '...';
function copyToClipboard(label, text) {
  if (window.clipboardData && window.clipboardData.setData) {
    // Internet Explorer-specific code path to prevent textarea being shown while dialog is visible.
    // Notification.success(`${label} [${text}] copied to clipboard.`, 3);
    return clipboardData.setData('Text', text);
  } else if (document.queryCommandSupported && document.queryCommandSupported('copy')) {
    var textarea = document.createElement('textarea');
    textarea.textContent = text;
    textarea.style.position = 'fixed'; // Prevent scrolling to bottom of page in Microsoft Edge.
    document.body.appendChild(textarea);
    textarea.select();
    try {
      return document.execCommand('copy'); // Security exception may be thrown by some browsers.
    } catch (ex) {
      console.warn('Copy to clipboard failed.', ex);
      return false;
    } finally {
      // Notification.success(`${label} [${text}] copied to clipboard.`, 3);
      document.body.removeChild(textarea);
    }
  }
}
var Base = /*#__PURE__*/function (_React$Component) {
  function Base() {
    var _this;
    (0, _classCallCheck2.default)(this, Base);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Base, [].concat(args));
    (0, _defineProperty2.default)(_this, "context", void 0);
    (0, _defineProperty2.default)(_this, "contentRef", /*#__PURE__*/React.createRef());
    (0, _defineProperty2.default)(_this, "copyId", void 0);
    (0, _defineProperty2.default)(_this, "rafId", void 0);
    // Locale
    (0, _defineProperty2.default)(_this, "expandStr", void 0);
    (0, _defineProperty2.default)(_this, "copyStr", void 0);
    (0, _defineProperty2.default)(_this, "copiedStr", void 0);
    (0, _defineProperty2.default)(_this, "state", {
      copied: false,
      ellipsisText: '',
      ellipsisContent: null,
      isEllipsis: false,
      expanded: false,
      clientRendered: false
    });
    // =============== Expand ===============
    (0, _defineProperty2.default)(_this, "onExpandClick", function (e) {
      var _this$getEllipsis = _this.getEllipsis(),
        onExpand = _this$getEllipsis.onExpand;
      _this.setState({
        expanded: true
      });
      if (onExpand) {
        onExpand(e);
      }
    });
    // ================ Copy ================
    (0, _defineProperty2.default)(_this, "onCopyClick", function () {
      var _this$props = _this.props,
        children = _this$props.children,
        copyable = _this$props.copyable;
      var copyConfig = _objectSpread({}, (0, _typeof2.default)(copyable) === 'object' ? copyable : null);
      if (copyConfig.text === undefined) {
        copyConfig.text = String(children);
      }
      // copy(copyConfig.text || '');
      copyToClipboard('', copyConfig.text || '');
      _this.setState({
        copied: true
      }, function () {
        if (copyConfig.onCopy) {
          copyConfig.onCopy();
        }
        _this.copyId = window.setTimeout(function () {
          _this.setState({
            copied: false
          });
        }, 3000);
      });
    });
    // ============== Ellipsis ==============
    (0, _defineProperty2.default)(_this, "resizeOnNextFrame", function () {
      _raf.default.cancel(_this.rafId);
      _this.rafId = (0, _raf.default)(function () {
        // Do not bind `syncEllipsis`. It need for test usage on prototype
        _this.syncEllipsis();
      });
    });
    return _this;
  }
  (0, _inherits2.default)(Base, _React$Component);
  return (0, _createClass2.default)(Base, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({
        clientRendered: true
      });
      this.resizeOnNextFrame();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var children = this.props.children;
      var ellipsis = this.getEllipsis();
      var prevEllipsis = this.getEllipsis(prevProps);
      if (children !== prevProps.children || ellipsis.rows !== prevEllipsis.rows) {
        this.resizeOnNextFrame();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.clearTimeout(this.copyId);
      _raf.default.cancel(this.rafId);
    }
  }, {
    key: "getEllipsis",
    value: function getEllipsis(props) {
      var _ref2 = props || this.props,
        ellipsis = _ref2.ellipsis;
      if (!ellipsis) return {};
      return _objectSpread({
        rows: 1,
        expandable: false
      }, (0, _typeof2.default)(ellipsis) === 'object' ? ellipsis : null);
    }
  }, {
    key: "canUseCSSEllipsis",
    value: function canUseCSSEllipsis() {
      var clientRendered = this.state.clientRendered;
      var copyable = this.props.copyable;
      var _this$getEllipsis2 = this.getEllipsis(),
        rows = _this$getEllipsis2.rows,
        expandable = _this$getEllipsis2.expandable,
        suffix = _this$getEllipsis2.suffix,
        onEllipsis = _this$getEllipsis2.onEllipsis;
      if (suffix) return false;
      // Can't use css ellipsis since we need to provide the place for button
      if (copyable || expandable || !clientRendered || onEllipsis) {
        return false;
      }
      if (rows === 1) {
        return isTextOverflowSupport;
      }
      return isLineClampSupport;
    }
  }, {
    key: "syncEllipsis",
    value: function syncEllipsis() {
      var _this$state = this.state,
        ellipsisText = _this$state.ellipsisText,
        isEllipsis = _this$state.isEllipsis,
        expanded = _this$state.expanded;
      var _this$getEllipsis3 = this.getEllipsis(),
        rows = _this$getEllipsis3.rows,
        suffix = _this$getEllipsis3.suffix,
        onEllipsis = _this$getEllipsis3.onEllipsis;
      var children = this.props.children;
      if (!rows || rows < 0 || !this.contentRef.current || expanded) return;

      // Do not measure if css already support ellipsis
      if (this.canUseCSSEllipsis()) return;
      var _measure = (0, _util.default)((0, _findDOMNode.default)(this.contentRef.current), {
          rows: rows,
          suffix: suffix
        }, children, this.renderOperations(true), ELLIPSIS_STR),
        content = _measure.content,
        text = _measure.text,
        ellipsis = _measure.ellipsis;
      if (ellipsisText !== text || isEllipsis !== ellipsis) {
        this.setState({
          ellipsisText: text,
          ellipsisContent: content,
          isEllipsis: ellipsis
        });
      }
      if (onEllipsis) {
        onEllipsis(ellipsis);
      }
    }
  }, {
    key: "renderExpand",
    value: function renderExpand(forceRender) {
      var _this$getEllipsis4 = this.getEllipsis(),
        expandable = _this$getEllipsis4.expandable,
        symbol = _this$getEllipsis4.symbol;
      var _this$state2 = this.state,
        expanded = _this$state2.expanded,
        isEllipsis = _this$state2.isEllipsis;
      if (!expandable) return null;

      // force render expand icon for measure usage or it will cause dead loop
      if (!forceRender && (expanded || !isEllipsis)) return null;
      var expandContent;
      if (symbol) {
        expandContent = symbol;
      } else {
        expandContent = this.expandStr;
      }
      return /*#__PURE__*/React.createElement("a", {
        key: "expand",
        onClick: this.onExpandClick,
        "aria-label": this.expandStr
      }, expandContent);
    }
  }, {
    key: "renderCopy",
    value: function renderCopy() {
      var _this2 = this;
      var copied = this.state.copied;
      var copyable = this.props.copyable;
      if (!copyable) return;
      var title = copied ? this.copiedStr : this.copyStr;
      return /*#__PURE__*/React.createElement(_ykbStyledComponents.ThemeConsumer, null, function (theme) {
        return /*#__PURE__*/React.createElement(_Tooltip.default, {
          key: "copy",
          overlay: title,
          placement: "top"
        }, /*#__PURE__*/React.createElement(_Styled.CopyWrapper, {
          $copied: copied,
          onClick: _this2.onCopyClick,
          "aria-label": title,
          theme: theme
        }, copied ? /*#__PURE__*/React.createElement(_Icon.default, {
          name: "check"
        }) : /*#__PURE__*/React.createElement(_Icon.default, {
          name: "documents"
        })));
      });
    }
  }, {
    key: "renderOperations",
    value: function renderOperations(forceRenderExpanded) {
      return [this.renderExpand(forceRenderExpanded), this.renderCopy()].filter(function (node) {
        return node;
      });
    }
  }, {
    key: "renderContent",
    value: function renderContent() {
      var _this3 = this;
      var _this$state3 = this.state,
        ellipsisContent = _this$state3.ellipsisContent,
        isEllipsis = _this$state3.isEllipsis,
        expanded = _this$state3.expanded;
      var _this$props2 = this.props,
        component = _this$props2.component,
        children = _this$props2.children,
        className = _this$props2.className,
        type = _this$props2.type,
        disabled = _this$props2.disabled,
        style = _this$props2.style,
        restProps = (0, _objectWithoutProperties2.default)(_this$props2, _excluded);
      var direction = this.context.direction;
      var _this$getEllipsis5 = this.getEllipsis(),
        rows = _this$getEllipsis5.rows,
        suffix = _this$getEllipsis5.suffix;
      var textProps = (0, _omit.default)(restProps, ['copyable', 'ellipsis', 'mark', 'code', 'delete', 'underline', 'strong', 'keyboard']);
      var cssEllipsis = this.canUseCSSEllipsis();
      var cssTextOverflow = rows === 1 && cssEllipsis;
      var cssLineClamp = rows && rows > 1 && cssEllipsis;
      var textNode = children;
      var ariaLabel;

      // Only use js ellipsis when css ellipsis not support
      if (rows && isEllipsis && !expanded && !cssEllipsis) {
        var title = restProps.title;
        ariaLabel = title;
        if (!title && (typeof children === 'string' || typeof children === 'number')) {
          ariaLabel = String(children);
        }
        // We move full content to outer element to avoid repeat read the content by accessibility
        textNode = /*#__PURE__*/React.createElement("span", {
          title: ariaLabel,
          "aria-hidden": "true"
        }, ellipsisContent, ELLIPSIS_STR, suffix);
      } else {
        textNode = /*#__PURE__*/React.createElement(React.Fragment, null, children, suffix);
      }
      textNode = wrapperDecorations(this.props, textNode);
      return /*#__PURE__*/React.createElement(_LocaleContext.LocaleReceiver, {
        componentName: "Text",
        defaultLocale: _default2.default.Text
      }, function (localeCode, locale) {
        _this3.copyStr = locale.copy;
        _this3.copiedStr = locale.copied;
        _this3.expandStr = locale.expand;
        return /*#__PURE__*/React.createElement(_rcResizeObserver.default, {
          onResize: _this3.resizeOnNextFrame,
          disabled: !rows
        }, /*#__PURE__*/React.createElement(_Typography.default, (0, _extends2.default)({
          disabled: disabled,
          ellipsis: rows,
          ellipsisSingleLine: cssTextOverflow,
          ellipsisMultiLine: cssLineClamp,
          type: type,
          style: _objectSpread(_objectSpread({}, style), {}, {
            WebkitLineClamp: cssLineClamp ? rows : null
          }),
          component: component,
          ref: _this3.contentRef,
          "aria-label": ariaLabel,
          direction: direction,
          className: className
        }, textProps), textNode, _this3.renderOperations()));
      });
    }
  }, {
    key: "render",
    value: function render() {
      return this.renderContent();
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps) {
      var children = nextProps.children;
      return {};
    }
  }]);
}(React.Component);
(0, _defineProperty2.default)(Base, "defaultProps", {
  children: ''
});
var _default = exports.default = Base;
Base.defaultProps = {
  prefixCls: 'ykb-typography'
};